<template>
  <div class="questionBankAdmin">
    <div class="questionBankMain">
      <div class="questionBankTop">
        <div style="font-weight: bold;font-size: 16px;">题库管理</div>

        <div style="margin-top: 20px;">
          <el-form :inline="true" :model="formInline" size="small">
            <el-form-item label="题库名称">
              <el-input
                style="width:300px;"
                @keyup.enter.native="search"
                v-model="formInline.title"
                placeholder="请输入题库名称"
                clearable
                @change="search"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search">查询</el-button>

              <el-button type="primary" @click="resetting">重置</el-button>
            </el-form-item>

            <el-button type="primary" size="small" @click="addQuestionBank"
              >新增题库</el-button
            >

            <br />

            <el-form-item label="科目">
              <el-select
                style="width:200px;"
                @change="search"
                v-model="formInline.subject_id"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in subject_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="年份">
              <el-select
                style="width:200px;"
                @change="search"
                v-model="formInline.year_id"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in testQuestionBankYearList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="题库来源">
              <el-select
                style="width:200px;"
                @change="search"
                v-model="formInline.source_id"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in testQuestionBankSourceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="赛道/分项">
              <el-select
                @change="search"
                style="width:200px;"
                v-model="formInline.source_tag_id"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in testQuestionBankSourceTagList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="真题/集训方案">
              <el-select
                @change="search"
                style="width:200px;"
                v-model="formInline.match_bank_type"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in matchBankTypeList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="题库类型">
              <el-radio-group @change="search" v-model="formInline.is_admin">
                <el-radio label="1">平台题库</el-radio>
                <el-radio label="2">校区题库</el-radio>
              </el-radio-group>
            </el-form-item>

            <div></div>
          </el-form>
        </div>
      </div>

      <div class="question_wrapper">
        <el-table
          size="small"
          :data="tableData"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }"
          stripe
          height="52vh"
        >
          <el-table-column align="center" width="50" label="序号">
            <template slot-scope="scope">{{
              scope.$index + 1 + 20 * (formInline.page_no - 1)
            }}</template>
          </el-table-column>

          <el-table-column align="center" width="80" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 37.5px; height: 17px;border-radius: 2px;"
                :src="scope.row.cover_url"
                fit="fill"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            align="left"
            width="200"
            label="题库名称"
            prop="title"
          >
          </el-table-column>

          <el-table-column align="left" label="科目" prop="subjectName">
          </el-table-column>

          <el-table-column align="left" label="年份">
            <template slot-scope="scope">
              <span>{{ scope.row.yearTitle }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="来源" prop="">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceInfo != null">{{
                scope.row.sourceInfo.title
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="分项">
            <template slot-scope="scope">
              <span v-if="scope.row.tagRelationInfoArr.length > 0">
                {{ scope.row.tagRelationInfoArr[0].tagInfo.title }}</span
              >
            </template>
          </el-table-column>
          <el-table-column align="left" label="真题/集训" width="150">
            <template slot-scope="scope">
              <span>{{
                scope.row.match_bank_type === 1 ? "真题" : "集训"
              }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="题数">
            <template slot-scope="scope">
              <span style="cursor: pointer;" @click="ResetQuestionNum(scope.row)">{{ scope.row.question_num }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="formInline.is_admin=='2'" align="left" label="所属校区" prop="schoolName">
          </el-table-column>

          <el-table-column align="center" label="发布状态">
            <template slot-scope="scope">
              <span
                style="color:grey;cursor: pointer;"
                @click="adminChangeQuestionBankPostState(scope.row.id, '1')"
                v-if="scope.row.post_state == 2"
              >
                未发布
              </span>
              <span
                @click="adminChangeQuestionBankPostState(scope.row.id, '2')"
                style="color:green;cursor: pointer;"
                v-if="scope.row.post_state == 1"
              >
                已发布
              </span>
            </template>
          </el-table-column>

          <el-table-column align="center" width="100" label="排序">
            <template slot-scope="scope">{{ scope.row.sort_num }}</template>
          </el-table-column>

          <el-table-column
            align="center"
            label="操作"
            fixed="right"
            width="200"
          >
            <template slot-scope="scope">
              <el-link
                class="quest_btn"
                type="primary"
                @click="goNext(scope.row)"
                >题目</el-link
              >

              <el-link
                class="quest_btn"
                type="primary"
                @click="edit(scope.row)"
                :disabled="scope.row.educational_institution_id !== null"
                >编辑</el-link
              >
              <el-link
                :disabled="scope.row.educational_institution_id !== null"
                class="quest_btn"
                type="primary"
                @click="adminDeleteQuestionBank(scope.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px;">
        <div style="text-align: right;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="formInline.page_no"
            layout="total, prev, pager, next"
            :total="formInline.total"
            :page-size="formInline.page_size"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      top="8vh"
      title="题库信息"
      :visible.sync="dialogVisible"
      width="650px"
      :before-close="handleClose"
    >
      <el-form :inline="true" :model="formLabelAlign">
        <el-form-item label="排序" required>
          <el-input-number
            v-model="formLabelAlign.sort_num"
            :precision="1"
            :step="0.1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="名称" required>
          <el-input
            style="width:495px;"
            v-model="formLabelAlign.title"
            placeholder="请输入题库名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="简介" required>
          <el-input
            v-model="formLabelAlign.desc"
            placeholder="请输入题库简介"
            style="width:495px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="* 来源">
          <el-select
            style="width:200px;"
            v-model="formLabelAlign.source_id"
            placeholder="请选择"
            clearable
            @change="FilterTagList"
          >
            <el-option
              v-for="item in testQuestionBankSourceList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="* 赛道/分项">
          <el-select
            style="width:200px;"
            v-model="formLabelAlign.source_tag_id"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in testQuestionBankSourceTagList1"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="科目" required>
          <el-select
            style="width:200px;"
            v-model="formLabelAlign.subject_id"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in subject_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="* 年份">
          <el-select
            style="width:235px;"
            v-model="formLabelAlign.year_id"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in testQuestionBankYearList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 真题/集训方案">
          <el-select
            style="width:200px;"
            v-model="formLabelAlign.match_bank_type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in matchBankTypeList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="题数">
          <el-input-number
            v-model="formLabelAlign.question_num"
          ></el-input-number>
        </el-form-item>

        <br />
        <el-form-item label="封面" required>
          <el-upload
            action=""
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :on-change="handleChangeFile"
            :auto-upload="false"
            :limit="1"
            :file-list="formLabelAlign.imgList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="adminAddOrUpdateQuestionBank"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import uploadFile from '@/config/uploadFile'

import {
  adminGetTestQuestionBankSourceListWit,
  adminGetTestQuestionBankSourceTagListWithoutPage,
  adminGetTestQuestionBankYearListWithoutPage,
  adminGetQuestionBankList,
  // getSubjectList,
  adminAddOrUpdateQuestionBank,
  adminGetUniqueSubjectList,
  adminChangeQuestionBankPostState,
  adminDeleteQuestionBank,
} from '@/api/admin.js'
export default {
  data() {
    return {
      isShow2: false,
      title: '',
      subject_id: '',
      year_id: '',
      source_id: '',
      source_tag_id: '',
      tagIdArr: '',
      subject_list: [],
      options: [],
      formLabelAlign: {
        value: true,
        sort_num: 0,
        imgList: [],
        year_id: '',
        title: '',
        desc: '',
        subject_id: '',
        source_tag_id: '',
        match_bank_type: '',
        source_id: '',
        question_num:0
      },
      dialogVisible: false,
      subjectList1: [],
      affiliationLsit: [
        {
          name: '全部',
        },
        {
          name: '平台',
        },
        {
          name: '校区',
        },
      ],
      matchBankTypeList: [
        { title: '真题', id: '1' },
        { title: '集训方案', id: '2' },
      ],
      itemizeList: [],
      itemizeList1: [],
      sourceList: [],
      sourceList1: [],
      tabPosition: '1',
      tableData: [],

      activeIndex: 0,
      activeIndex1: 0,
      activeIndex2: 1,
      activeIndex3: 0,
      activeIndex4: null,
      activeIndex5: null,
      uploadFileTime: false,
      questionBankId: '',
      isShow: false,

      //查询
      formInline: {
        title: "",
        subject_id: "",
        source_tag_id: "",
        match_bank_type: "",
        source_id: "",
        post_state: "",
        is_admin: "1", //校区题库还是平台题库
        page_no:1,
        page_size:20,
        total:0
      },

      //筛选条件
      isShow1: true,
      testQuestionBankSourceList: [],
      testQuestionBankSourceTagList: [],
      testQuestionBankSourceTagList1: [], //编辑题库弹窗页面数据
      testQuestionBankYearList: [],
      testQuestionTagList: [],

      FilterTagData: [], //分项
    }
  },

  watch: {
    formInline: {
      handler(newVal, oldVal) {
        // 当 formInline 对象的任何属性发生变化时执行的回调函数
        console.log("formInline 值发生变化", newVal, oldVal);

        console.log("新值");
        console.log(newVal);

        sessionStorage.setItem(
          "testing_questionBankAdmin_formInline",
          JSON.stringify(newVal)
        );
      },
      deep: true, // 开启深度监听，用于监听 formInline 对象属性的值变化
    },
  },

  mounted() {
    console.log("默认筛选条件");
    console.log(sessionStorage.getItem("testing_questionBankAdmin_formInline"));

    if (
      JSON.parse(sessionStorage.getItem("testing_questionBankAdmin_formInline"))
    ) {
      this.formInline = JSON.parse(
        sessionStorage.getItem("testing_questionBankAdmin_formInline")
      );
    }

    this.adminGetTestQuestionBankYearListWithoutPage(); //年份查询
    this.adminGetQuestionBankList(); //题库
    this.getSubjectList1(); //科目列表
    this.adminGetTestQuestionBankSourceListWit(); //来源列表
    this.adminGetTestQuestionBankSourceTagListWithoutPage();
  },
  methods: {

    ResetQuestionNum(row)
    {
      console.log("更新题库题目数量");
      console.log(row);
    },

    resetting() {
      console.log("初始化筛选条件");

      (this.formInline =
        //查询
        {
          title: "",
          subject_id: "",
          source_tag_id: "",
          match_bank_type: "",
          source_id: "",
          post_state: "",
          is_admin: "1", //校区题库还是平台题库
          page_no:1,
          page_size:20,
          total:20
        }),
        sessionStorage.setItem(
          "testing_questionBankAdmin_formInline",
          JSON.stringify(this.formInline)
        );

      this.search();
    },

    //编辑题库时候根据来源过滤分项
    FilterTagList() {
      this.formLabelAlign.source_tag_id = ''

      this.adminGetTestQuestionBankSourceTagListWithoutPage1()
    },

    adminDeleteQuestionBank(id) {
      this.$confirm('确定删除该题库吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminDeleteQuestionBank({
          questionBankId: id,
        }).then((res) => {
          console.log('删除题库')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.adminGetQuestionBankList()
          }
        })
      })
    },
    //发布状态
    adminChangeQuestionBankPostState(id, cmd) {
      adminChangeQuestionBankPostState({
        questionBankId: id,
        post_state: cmd,
      }).then((res) => {
        console.log('题库发布状态')
        console.log(res)

        this.adminGetQuestionBankList()
      })
    },

    //state 2 未发布 state 1 已发布
    PostState(id, state) {
      console.log('发布状态切换')
      console.log(id, state)
    },

    edit(row) {
      console.log('编辑题库')
      console.log(row)

      //如果是平台题库
      if (!row.educational_institution_id) {
        this.isShow = false
        this.questionBankId = row.id
        //题库信息初始化
        this.formLabelAlign.sort_num = row.sort_num
        this.formLabelAlign.subject_id = row.subject_id
        this.formLabelAlign.post_state = row.post_state
        this.formLabelAlign.title = row.title
        this.formLabelAlign.desc = row.content
        this.formLabelAlign.year_id = row.year_id
        this.formLabelAlign.match_bank_type = String(row.match_bank_type)

        this.formLabelAlign.question_num = row.question_num;

        if (row.sourceInfo) {
          this.formLabelAlign.source_id = row.sourceInfo.id
          this.adminGetTestQuestionBankSourceTagListWithoutPage1()
        } else {
          this.formLabelAlign.source_id = ''
        }
        if (row.tagRelationInfoArr.length > 0) {
          this.formLabelAlign.source_tag_id =
            row.tagRelationInfoArr[0].tagInfo.id
        } else {
          this.formLabelAlign.source_tag_id = ''
        }

        this.formLabelAlign.imgList = [
          {
            url: row.cover_url,
            name: row.cover_url.split('/')[row.cover_url.split('/').length - 1],
          },
        ]

        this.dialogVisible = true
      } else {
        this.isShow = true
      }
    },
    adminAddOrUpdateQuestionBank() {
      if (this.questionBankId) {
        console.log('编辑题目提交')
        console.log(this.formLabelAlign)

        adminAddOrUpdateQuestionBank({
          questionBankId: this.questionBankId,
          subject_id: this.formLabelAlign.subject_id,
          source_id: this.formLabelAlign.source_id,
          title: this.formLabelAlign.title,
          content: this.formLabelAlign.desc,
          sort_num: this.formLabelAlign.sort_num,
          cover_url: this.formLabelAlign.imgList[0].url,
          year_id: this.formLabelAlign.year_id,
          tagIdArr:
            this.formLabelAlign.source_tag_id == ''
              ? JSON.stringify([])
              : JSON.stringify([this.formLabelAlign.source_tag_id]),
          post_state: this.formLabelAlign.post_state,
          match_bank_type: this.formLabelAlign.match_bank_type,
          question_num:this.formLabelAlign.question_num
        }).then((res) => {
          console.log('添加题库')
          console.log(res)
          if (res.is_update) {
            this.$message.success("编辑成功");
            this.dialogVisible = false;
            this.source_id = "";
            this.adminGetQuestionBankList();
          }
        })
      } else {
        adminAddOrUpdateQuestionBank({
          subject_id: this.formLabelAlign.subject_id,
          source_id: this.formLabelAlign.source_id,
          title: this.formLabelAlign.title,
          content: this.formLabelAlign.desc,
          sort_num: this.formLabelAlign.sort_num,
          cover_url: this.formLabelAlign.imgList[0].url,
          year_id: this.formLabelAlign.year_id,
          tagIdArr:
            this.formLabelAlign.source_tag_id == ''
              ? JSON.stringify([])
              : JSON.stringify([this.formLabelAlign.source_tag_id]),
          post_state: 2,
          match_bank_type: this.formLabelAlign.match_bank_type,
        }).then((res) => {
          console.log('添加题库')
          console.log(res)
          if (res.is_created) {
            this.$message.success("添加成功");
            this.dialogVisible = false;
            this.adminGetQuestionBankList();
          }
        })
      }
    },
    handleRemove() {},
    uploadFile() {},
    async handleChangeFile(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList)
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true
      await uploadFile(list, this.$store.state.user.userInfo.code).then(
        (res) => {
          console.log('上传图片')
          console.log(res)
          this.formLabelAlign.imgList = res
          this.uploadFileTime = false
        }
      )
    },
    getSubjectList1() {
      adminGetUniqueSubjectList({
        page_no: 1,
        page_size: 200,
      }).then((res) => {
        this.subject_list = res.subject_list
      })
    },

    search() {
      this.formInline.page_no = 1;
      this.adminGetQuestionBankList();
    },
    handleCurrentChange(val) {
      this.formInline.page_no = val;
      this.adminGetQuestionBankList();
    },
    adminGetQuestionBankList() {
      adminGetQuestionBankList({
        title: this.formInline.title,
        subject_id: this.formInline.subject_id,
        year_id: this.formInline.year_id,
        source_tag_id: this.formInline.source_tag_id, //分项列表
        source_id: this.formInline.source_id, //来源ID
        is_admin: this.formInline.is_admin,
        match_bank_type: this.formInline.match_bank_type,
        page_no: this.formInline.page_no,
        page_size: this.formInline.page_size,
      }).then((res) => {
        console.log('题库信息')
        console.log(res)

        this.tableData = res.questionBankList;
        this.formInline.total = res.total;
      });
    },
    goNext(row) {
      console.log(row, 8446556)
      this.$router.push({
        name: 'questionBankAdminDetails',
        query: {
          id: row.id,
          subject_id: row.subject_id,
        },
      })
    },

    addQuestionBank() {
      this.title = "新增题库";
      this.adminGetTestQuestionBankSourceListWit();
      this.adminGetTestQuestionBankYearListWithoutPage();
      this.getSubjectList1();

      this.formLabelAlign.sort_num = 0;
      this.formLabelAlign.title = "";
      this.formLabelAlign.desc = "";
      this.formLabelAlign.subject_id = "";
      this.formLabelAlign.year = "";
      this.formLabelAlign.imgList = [];

      this.activeIndex4 = 0;
      this.source_id = "";
      this.activeIndex5 = 0;
      this.tagIdArr = "";

      this.itemizeList1 = [];
      this.dialogVisible = true;

      this.questionBankId = "";

    },
    handleClose() {
      this.dialogVisible = false
    },
    changeSource() {
      console.log('来源切换')

      this.adminGetTestQuestionBankSourceTagListWithoutPage()
    },
    changeitemize(val, index) {
      console.log(val)
      console.log(index)
      this.activeIndex5 = val.id
      this.tagIdArr = val.id
    },
    //来源列表
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        console.log(res, 95656)
        this.testQuestionBankSourceList = res.testQuestionBankSourceList
      })
    },

    adminGetTestQuestionBankSourceTagListWithoutPage1() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.formLabelAlign.source_id,
      }).then((res) => {
        console.log('编辑题目对应来源的分项')
        console.log(res.testQuestionBankSourceTagList)
        this.testQuestionBankSourceTagList1 = res.testQuestionBankSourceTagList
      })
    },

    adminGetTestQuestionBankSourceTagListWithoutPage() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.formInline.source_id,
      }).then((res) => {
        console.log("对应来源的分项");
        console.log(res.testQuestionBankSourceTagList);
        this.testQuestionBankSourceTagList = res.testQuestionBankSourceTagList;
        this.adminGetQuestionBankList();
      });
    },

    adminGetTestQuestionBankYearListWithoutPage() {
      adminGetTestQuestionBankYearListWithoutPage().then((res) => {
        this.testQuestionBankYearList = res.testQuestionBankYearList
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.questionBankAdmin {
  // margin: 10px;
  padding: 10px 10px 10px 10px;
}

.questionBankMain {
  background: white;
  border-radius: 5px;
  min-height: calc(100vh - 80px);
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
}

.questionBankTop {
  box-sizing: border-box;
}

.quest_btn {
  margin-left: 10px;
  margin-right: 10px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.questionBankAdminList {
  width: 100%;
  padding: 20px;
  background: #f8f8f8;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.tagStyle {
  padding: 2px 7px;
  background-color: #f8f8f8;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}

.tagStyle1 {
  padding: 2px 5px;
  background-color: #f8f8f8;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
